import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { SORT_ITEM_TYPE } from '../../constants/constant';

const DraggableSortItem = ({ item, index, moveItem, renderItem }) => {

    const ref = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: SORT_ITEM_TYPE,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(draggedItem, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = draggedItem.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }
            // Time to actually perform the action
            moveItem(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            draggedItem.index = hoverIndex;
        },
    })


    const [{ isDragging }, drag] = useDrag({
        type: SORT_ITEM_TYPE,
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    drag(drop(ref));

    return (
        <div ref={ref} data-handler-id={handlerId} className={`tile w-100 ${isDragging ? 'dragging' : ''}`}>
            {renderItem(item, isDragging)}
        </div>
    );
}

export default DraggableSortItem;